/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthenticated use, duplication or disclosure is prohibited.

***************************************************************************/

import { Auth } from 'aws-amplify'
import router from '../router';
import Api from '@/services/api'

export const auth = {

    namespaced: true,

    state: {
        isAuthenticated: false,
        user: null,
        subscriptions: null,
        hasSubscription: false,
    },

    getters: {
        isAuthenticated: (state) => { return state.isAuthenticated },
        hasSubscription: (state) => { return state.hasSubscription },
        subscriptions: (state) => { return state.subscriptions },
        currentSubscription: (state) => {
            if (state.subscriptions.length > 0) {
                return state.subscriptions[0]
            } else {
                return null
            }
        },
        user: (state) => { return state.user },
        idJwtToken: (state) => { 
            if ( state.isAuthenticated ) {
                return state.user.signInUserSession.idToken.jwtToken
            } else {
                return null
            }
        },
        accessJwtToken: (state) => { 
            if ( state.isAuthenticated ) {
                return state.user.signInUserSession.accessToken.jwtToken
            } else {
                return null
            }
        }
    },

    actions: {

        async loggedIn({commit, dispatch, rootState}, user) {
            try {
                const expires = user.getSignInUserSession().getAccessToken().payload.exp - Math.floor(new Date().getTime() / 1000)
                console.log(`Token expires in ${expires} seconds`)
                // setTimeout(
                //     async () => {
                //         console.log('Token expired. Logout user automatically')
                //         await dispatch('logout')
                //     },
                //     expires * 1000
                // )                
                commit('user', user)
                dispatch('fetchWebApps', null, { root: true })
                dispatch('fetchSubscription') // Mainly for getting subscription status
                .then(() => {
                    console.log("Redirecting to targetNamedRoute: ", rootState.targetNamedRoute)
                    router.push({name: rootState.targetNamedRoute})
                    dispatch('setTargetNamedRoute', null, { root: true })                    
                })
            } catch (err) {
                console.log("Error when processing login event", err)
                commit('user', null)
            }

        },

        async fetchSubscription({commit, dispatch}){
            console.log("Fetching subscription data...");
            Api.user.getSubscriptionStatus()
            .then((response) => {
                const subscriptions = response.data
                console.log("Subscriptions data: ", subscriptions);
                commit('subscriptions', subscriptions)
            })
        },

        async fetchUser({commit, dispatch}){
            console.log("Fetching user data...");
            return new Promise(
                function(resolve, reject) {
                    Auth.currentAuthenticatedUser({bypassCache: true})
                    .then((user) => {
                        console.log("User data fetched.")
                        const expires = user.getSignInUserSession().getAccessToken().payload.exp - Math.floor(new Date().getTime() / 1000)
                        console.log(`Token expires in ${expires} seconds`)
                        // setTimeout(
                        //     async () => {
                        //         console.log('Token expired. Logout user automatically')
                        //         await dispatch('logout')
                        //     },
                        //     expires * 1000
                        // )                            
                        commit('user', user)
                        dispatch('fetchSubscription')
                    })
                    .catch((err) => {
                        console.log("No user data found.")
                        commit('user', null)    
                    })
                    .finally(() => {
                        resolve();
                    })
                }                
            )
        },

        async logout({commit}, message){
            console.log("User logged out.")
            await Auth.signOut()
            commit('user', null)
            if (router.name != 'auth') {
                router.push({name: 'auth', params: { initAuthState: 'signin' } })
            }
        },

    },
    mutations: {

        user(state, user){
            console.log("Storing user info (ONLY 'attributes', 'username', 'signInUserSession', 'subscription') in Vuex.", user)
            state.isAuthenticated = !!user && user.attributes && user.attributes.email_verified
            state.user = user ? {
                attributes: user.attributes,
                username: user.username,
                signInUserSession: user.signInUserSession,
                subscription: user.subscription
            } : null
        },

        subscriptions(state, subscriptions) {
            console.log("Storing subscription info in Vuex.", subscriptions)
            state.hasSubscription = !!subscriptions && subscriptions.length > 0
            state.subscriptions = subscriptions
        }

    }
};
